import { Avatar, Box, Card, CardActions, CardContent, CardHeader, IconButton, Link, Typography, } from "@mui/material";
import Confirm from "components/Dialog";
import { DeleteIcon, EditIcon } from "components/Icons";
import { useBasePath } from "components/Providers";
import { useState } from "react";
import { FaRegStar } from "react-icons/fa";
import { GiStairsGoal } from "react-icons/gi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { destroy } from "store/evaluation/admin-goal";


export default function GoalsList({ goalsList }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const [confirm, setConfirm] = useState(false)
  const [toDelete, setToDelete] = useState(null)
  
    const onDelete = (id) => {
      setToDelete(id)
      setConfirm(true)
    }
  
    const onConfirm = () => {
      setConfirm(false)
      dispatch(destroy({ id: toDelete }))
    }

  return (
    <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'}>
      {goalsList?.map((item, index) => (
        <Card key={`goals-${index}`}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'primary.main' }} aria-label="icon">
                {item?.adminEvaluationStandard?.name === 'iReady Goal' ? <FaRegStar /> : <GiStairsGoal />}
              </Avatar>
            }
            title={item?.adminEvaluationStandard?.name}
            subheader={<span>Uploaded File: <Link href={item?.file?.location} target="_blank">{item?.file?.name}</Link></span>}
          />
          <CardContent>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {item.goal}
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <IconButton aria-label="edit">
              <EditIcon onClick={() => navigate(`${basePath}/goal/${item.id}`)}/>
            </IconButton>
            <IconButton aria-label="delete" onClick={() => onDelete(item.id)}>
              <DeleteIcon />
            </IconButton>
          </CardActions>
        </Card>
      ))}
      <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} message="Are you sure you want to delete this goal?" />
    </Box>
  )
}
